const elementCategories = {
  'Basic Elements': ['Text', 'Image', 'Button'],
  Shapes: ['Rectangle', 'Star', 'Polygon', 'Circle'],
};

export default elementCategories;
